export default "__VITE_ASSET__DeGmnoQz__"